/* eslint-disable react-hooks/rules-of-hooks */
import { useSetFieldValue } from "formik";
import { FlexContext } from "../models/flexible/flex-context";
import { FlexFieldController } from "../models/flexible/flex-field-controller";
import { FlexSectionController } from "../models/flexible/flex-section-controller";
import { FlexSectionSchema } from "../models/flexible/flex-section-schema";
import { createSingleSectionInstanceInitialValues } from "../models/flexible/initial-values";

export class AdverseEventSectionController implements FlexSectionController {
	context: FlexContext = {} as any;

	constructor(
		readonly schema: FlexSectionSchema,
		readonly path: string,
		readonly fieldControllers: Array<FlexFieldController>,
		readonly sectionControllers: Array<FlexSectionController>
	) { }

	useIsSectionOpenByDefault(): boolean {
		return false;
	}

	useProcessSectionStateChange(): (isOpen: boolean) => void {
		const setFieldValue = useSetFieldValue();

		return (isOpen) => {
			if (isOpen) {
				setFieldValue(this.schema.localizableKey, [createSingleSectionInstanceInitialValues(this, {}, {})]);
				return;
			}

			setFieldValue(this.schema.localizableKey, []);
		};
	}
}
